<template>
  <div>
    <h5>{{ $t('Referencias') }}</h5>
    <div class="card shadow seat-reference">
      <table>

        <tr>
          <td>
            <ol>
              <li class="seat">
                <input type="checkbox">
                <label>-</label>
              </li>
            </ol>
          </td>
          <td class="seat-reference-text">{{ $t('Disponible') }}</td>
          <td>
            <ol>
              <li class="seat">
                <input type="checkbox" disabled>
                <label>-</label>
              </li>
            </ol>
          </td>
          <td class="seat-reference-text">{{ $t('No Disponible') }}</td>
        </tr>

        <tr>
          <td>
            <ol>
              <li class="seat">
                <input type="checkbox" checked="">
                <label>-</label>
              </li>
            </ol>
          </td>
          <td class="seat-reference-text">{{ $t('Seleccionado') }}</td>
          <td>
            <ol>
              <li class="seat">
                <input type="checkbox" disabled>
                <label>-</label>
              </li>
            </ol>
          </td>
          <td class="seat-reference-text">{{ $t('Otro Pasajero') }}</td>
        </tr>

        <tr>
          <td>
            <div class="exit-legend" aria-hidden="true">
              <span>{{ $t('EXIT') }}</span>
            </div>
          </td>
          <td class="seat-reference-text">{{ $t('Salida') }}</td>
          <td>
            <ol>
              <li class="seat">
                <span class="bthr1"><i class="fas fa-restroom"></i></span>
              </li>
            </ol>
          </td>
          <td class="seat-reference-text">{{ $t('Baños') }}</td>
        </tr>

      </table>
    </div>
  </div>

</template>

<script>
  export default {
    name: "SeatmapReferences"
  }
</script>

<style scoped>

</style>